import Vue from "vue";
import CONFIG from "./../../config.js";

let actions = {
  loginError (context, params) {
    context.commit("loginError", params);
  },
  otpError (context, params) {
    context.commit("otpError", params);
  },
  getOTP (context, params) {
    context.commit("addLog", { request: "GetOTP" });
    context.commit("setMobile", params.mobile);
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(CONFIG.getEndpoint("getOTP"), params, {
          withCredentials: true
        })
        .then(response => {
          context.commit("setSessionID", response.data);
          context.commit("loginError", { error: false });
          context.commit("removeLog", { request: "GetOTP" });
          localStorage.setItem("sessionID", response.data.session_id);
          resolve();
        })
        .catch(err => {
          reject(err.response.data);
          context.commit("removeLog", { request: "GetOTP" });
        });
    });
  },
  resendOTP (context, params) {
    context.commit("addLog", { request: "resendOTP" });
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(CONFIG.getEndpoint("resendOTP"), params, {
          withCredentials: true
        })
        .then(() => {
          resolve();
          context.commit("removeLog", { request: "resendOTP" });
        })
        .catch(err => {
          reject(err.response.data);
          context.commit("removeLog", { request: "resendOTP" });
        });
    });
  },
  login (context, params) {
    context.commit("addLog", { request: "login" });
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(CONFIG.getEndpoint("login"), params, {
          withCredentials: true
        })
        .then(() => {
          // localStorage.removeItem("sessionID");
          context.commit("removeLog", { request: "login" });
          resolve();
        })
        .catch(err => {
          context.commit("removeLog", { request: "login" });
          reject(err.response.data);
        });
    });
  },
  logout (context) {
    context.commit("addLog", { request: "logout" });
    return new Promise((resolve, reject) => {
      Vue.axios
        .delete(CONFIG.getEndpoint("logout"), {
          withCredentials: true,
          xsrfCookieName: "SSO_TOKEN"
        })
        .then(() => {
          localStorage.clear()
          context.dispatch("registerMixpanelDefaults", {
            uuid: false
          });
          context.commit("removeLog", { request: "logout" });
          resolve();
        })
        .catch(err => {
          context.commit("removeLog", { request: "logout" });
          reject(err);
        });
    });
  },
  getUser (context) {
    context.commit("addLog", { request: "getUser" });
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(CONFIG.getEndpoint("userProfile"), {
          withCredentials: true,
          xsrfCookieName: "SSO_TOKEN"
        })
        .then(response => {
          context.dispatch("registerMixpanelDefaults", {
            uuid: response.data.uuid
          });
          context.commit("setUser", response.data);
          context.commit("removeLog", { request: "getUser" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("unsetUser");
          context.commit("removeLog", { request: "getUser" });
          reject(err);
        });
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/store/login/actions.js